<template>
  <div class="container-fluid">
    <div class="row">
      <div class="col-12">
        <div class="page-table-header">
          <PageHeader :page-title="'Client bank details'">
            <template v-slot:buttons>
              <b-button
                class="button title-container__controls-item"
                :variant="isShowFilter ? 'secondary' : 'info'"
                @click="toggleShowFilter"
              >
                <span class="material-icons icon-image-preview">
                  tune
                </span>
                Filters
              </b-button>
              <b-button
                v-if="$can(permissions.CreateFinancesClientBankDetails)"
                class="button"
                variant="success"
                @click.prevent="showCreateModal"
                :disabled="isDataPageLoading"
              >
                Create
              </b-button>
            </template>
          </PageHeader>

          <Filters
            v-show="isShowFilter"
            textButtonSubmit="Filter"
            :data="getFilters"
            :isLoading="isDataPageLoading"
            @submit="setFilterBankDetails"
          />

          <TableForPage
            v-if="getBankDetailsTableData.length"
            ref="table"
            :tableData="getBankDetailsTableData"
            :slots="table.slots"
            :fields="getTableFields"
            :perPage="getBankDetails.per_page"
            :currentPage="getBankDetails.current_page"
            :totalRows="getBankDetails.total"
            :tableRowModalFields="tableRowModal.fields"
            :isEdit="$can(permissions.UpdateAllFinancesClientBankDetails)"
            :isRemove="$can(permissions.DeleteFinancesClientBankDetails)"
            isShowView
            isServerRender
            noLocalSorting
            @edit="showEditModal"
            @remove="removeBankDetails"
            @update="updateBankDetails"
          >
            <template v-slot:client="slotProps">
              {{ getFullNameClients(slotProps) }}
            </template>
            <template v-slot:rowModal.client="slotProps">
              <td class="entities-table-row-modal__label">Client</td>
              <td>
                {{ getFullNameRowModalClient(slotProps) }}
              </td>
            </template>
          </TableForPage>
          <div class="table__empty" v-else>
            Table is empty
          </div>
        </div>
      </div>
    </div>

    <FinancesClientsModal
      v-model="clientsModal.show"
      @submit="createFinanceClient"
    />
    <b-modal
      size="lg"
      hide-footer
      v-model="createModal.show"
      class="modal"
      @show="resetCreateModalForm"
    >
      <template v-slot:modal-header="{ cancel }">
        <h5 class="modal-title">{{createModal.title}}</h5>
        <button
          type="button"
          aria-label="Close"
          class="close"
          @click.prevent="cancel"
        >
          <span class="material-icons">
            close
          </span>
        </button>
      </template>
      <FormGenerator
        :data="createModal.form"
        :isLoading="isDataPageLoading"
        @submit="createBankDetails"
        :showReset="false"
        :textButtonSubmit="createModal.submitButtonText"
      >
        <template v-slot:form-footer-left-controllers="slotProps">
          <b-button
            class="btn button btn-secondary"
            @click.prevent="updateWithUpworkData"
          >
            Upwork account
          </b-button>
        </template>
        <template v-slot:SelectCreateClient="slotProps">
            <DropDownSelect
              v-model="slotProps.data.value"
              :items="slotProps.data.options"
              :selectLabel="slotProps.data.selectLabel"
              :valueField="slotProps.data.valueField"
              :label="slotProps.data.label"
              @input="selectClient"
            >
              <template>
                <b-dropdown-text>
                  <b-button
                    class="btn-primary"
                    size="sm"
                    @click.prevent="showClientsModal"
                  >
                    Create
                  </b-button>
                </b-dropdown-text>
              </template>
            </DropDownSelect>
        </template>
        <template v-slot:companyName="slotProps">
          <b-form-group v-if="isBusinessEntityCompany(slotProps.fields.business_entity_type)">
            <label>{{slotProps.data.label}}</label>
            <b-form-input
              v-model="slotProps.data.value"
              :required="slotProps.data.required"
              :placeholder="slotProps.data.placeholder"
            />
          </b-form-group>
        </template>
        <template v-slot:companyNameNational="slotProps">
          <b-form-group v-if="isBusinessEntityCompany(slotProps.fields.business_entity_type)">
            <label>{{slotProps.data.label}}</label>
            <b-form-input
              v-model="slotProps.data.value"
              :required="slotProps.data.required"
              :placeholder="slotProps.data.placeholder"
            />
          </b-form-group>
        </template>
      </FormGenerator>
    </b-modal>
    <b-modal
      size="lg"
      hide-footer
      v-model="editModal.show"
      class="modal"
    >
      <template v-slot:modal-header="{ cancel }">
        <h5 class="modal-title">{{editModal.title}}</h5>
        <button
          type="button"
          aria-label="Close"
          class="close"
          @click.prevent="cancel"
        >
          <span class="material-icons">
            close
          </span>
        </button>
      </template>
      <FormGenerator
        :data="editModal.form"
        @submit="editBankDetails"
        :showReset="false"
        :textButtonSubmit="editModal.submitButtonText"
      >
        <template v-slot:SelectCreateClient="slotProps">
          <DropDownSelect
            v-model="slotProps.data.value"
            :items="slotProps.data.options"
            :selectLabel="slotProps.data.selectLabel"
            :valueField="slotProps.data.valueField"
            :label="slotProps.data.label"
          >
            <template>
              <b-dropdown-text>
                <b-button
                  class="btn-primary"
                  size="sm"
                  @click.prevent="showClientsModal"
                >
                  Create
                </b-button>
              </b-dropdown-text>
            </template>
          </DropDownSelect>
        </template>
        <template v-slot:companyName="slotProps">
          <b-form-group v-if="isBusinessEntityCompany(slotProps.fields.business_entity_type)">
            <label>{{slotProps.data.label}}</label>
            <b-form-input
              v-model="slotProps.data.value"
              :required="slotProps.data.required"
              :placeholder="slotProps.data.placeholder"
            />
          </b-form-group>
        </template>
        <template v-slot:companyNameNational="slotProps">
          <b-form-group v-if="isBusinessEntityCompany(slotProps.fields.business_entity_type)">
            <label>{{slotProps.data.label}}</label>
            <b-form-input
              v-model="slotProps.data.value"
              :required="slotProps.data.required"
              :placeholder="slotProps.data.placeholder"
            />
          </b-form-group>
        </template>
      </FormGenerator>
    </b-modal>
  </div>
</template>

<script>
import TableForPage from '@tables/TableForPage'
import DropDownSelect from '@components/DropDownSelect'
import FinancesClientsModal from '@components/modals/FinancesClientsModal'
import Filters from '@components/Filter/Filter'
import FormGenerator from '@components/FormGenerator'
import PageHeader from '@components/PageHeader'
import BankDetailsMixin from '../mixins/BankDetailsMixin'

export default {
  name: 'FinanceClientsBankDetails',
  components: {
    TableForPage,
    Filters,
    DropDownSelect,
    FinancesClientsModal,
    FormGenerator,
    PageHeader
  },
  mixins: [BankDetailsMixin],
  data () {
    return {
      modalTitle: 'Clients Bank Details',
      ownershipId: 2,
      tableRowModal: {
        fields: [
          {
            key: 'address',
            label: 'Address'
          },
          {
            key: 'address_national',
            label: 'Address national'
          },
          {
            key: 'bank_address',
            label: 'Bank address'
          },
          {
            key: 'bank_address',
            label: 'Bank address'
          },
          {
            key: 'bank_correspondent_address',
            label: 'Bank correspondent address'
          },
          {
            key: 'bank_correspondent_account',
            label: 'Bank correspondent account'
          },
          {
            key: 'bank_correspondent_iban',
            label: 'Bank correspondent Iban'
          },
          {
            key: 'bank_correspondent_mfi',
            label: 'Bank correspondent MFI'
          },
          {
            key: 'bank_correspondent_name',
            label: 'Bank correspondent name'
          },
          {
            key: 'bank_correspondent_swift',
            label: 'Bank correspondent swift'
          },
          {
            key: 'bank_mfi',
            label: 'Bank MFI'
          },
          {
            key: 'bank_name',
            label: 'Bank Name'
          },
          {
            key: 'business_entity_type.type',
            label: 'Business entity type'
          },
          {
            key: 'city',
            label: 'City'
          },
          {
            key: 'city_national',
            label: 'City National'
          },
          {
            key: 'client',
            label: 'client',
            type: 'slot',
            slotName: 'client'
          },
          {
            key: 'company_name',
            label: 'Company name'
          },
          {
            key: 'company_name_national',
            label: 'Company name national'
          },
          {
            key: 'country.name',
            label: 'Country'
          },
          {
            key: 'currency.name',
            label: 'Currency'
          },
          {
            key: 'email',
            label: 'Email'
          },
          {
            key: 'extract_from_unified_register',
            label: 'Extract From Unified Register'
          },
          {
            key: 'first_name',
            label: 'First Name'
          },
          {
            key: 'last_name',
            label: 'Last Name'
          },
          {
            key: 'last_name_national',
            label: 'Last Name National'
          },
          {
            key: 'first_name_national',
            label: 'First Name National'
          },
          {
            key: 'iban',
            label: 'Iban'
          },
          {
            key: 'phone',
            label: 'Phone'
          },
          {
            key: 'second_name_national',
            label: 'Second Name National'
          },
          {
            key: 'summary',
            label: 'Summary'
          },
          {
            key: 'swift',
            label: 'Swift'
          },
          {
            key: 'tax_registration_number',
            label: 'Tax Registration Number'
          },
          {
            key: 'zip_code',
            label: 'Zip Code'
          }
        ]
      },
      currentFields: [
        'name',
        'client.full_name',
        'currency.name',
        'country.name',
        'business_entity_type.type',
        'first_name',
        'last_name',
        'company_name',
        'actions'
      ]
    }
  },
  computed: {
    currentTabComponent: function () {
      return 'tabHome'
    },
    getFilters () {
      const currentFilers = (({
        clientId,
        currencyId,
        country,
        businessEntityTypeId,
        firstName,
        lastName,
        companyName
      }) => ({
        clientId,
        currencyId,
        country,
        businessEntityTypeId,
        firstName,
        lastName,
        companyName
      }))(this.filters)

      return currentFilers
    },
    formMock () {
      return {
        'id': {
          name: 'id'
        },
        'updateUpworkButton': {
          type: 'slot',
          slotName: 'updateUpworkButton',
          class: 'col-12'
        },
        'client': {
          type: 'slot',
          slotName: 'SelectCreateClient',
          name: 'client_id',
          label: 'Clients*',
          selectLabel: 'full_name',
          valueField: 'id',
          options: [],
          value: null,
          validation: [
            { name: 'required' }
          ],
          class: 'col-12'
        },
        ...this.mainFormMock
      }
    }
  },
  methods: {
    getFullNameClients (slotProps) {
      if (!slotProps.item || !slotProps.item.client) return

      return `${slotProps.item.client.first_name} ${slotProps.item.client.last_name}`
    },
    getFullNameRowModalClient (slotProps) {
      if (!slotProps.field) return

      return `${slotProps.field.first_name} ${slotProps.field.last_name}`
    },
    showClientsModal () {
      this.clientsModal.show = true
    },
    hideClientsModal () {
      this.clientsModal.show = false
    },
    createFinanceClient (fields) {
      const data = this.prepareDataForEditAndCreateRequest(fields)

      this._toggleDataPageLoading(async () => {
        await this.$api.finances.createClients(data)
        this.$snotify.success(
          'Client successfully created',
          'Success',
          this.$store.state.snotify
        )
        await this.$api.finances.getAllFinanceClients()
        this.createModal.form.client.options = this.getAllClients
        this.editModal.form.client.options = this.getAllClients
        this.hideClientsModal()
      })
    },
    selectClient (client) {
      const selectedClient = this.getAllClients.find(item => item.id === client.id)
      if (this.createModal.show) {
        this.createModal.form.client.value = selectedClient
        this.createModal.form.address.value = selectedClient.address
        this.createModal.form.address_national.value = selectedClient.address
        this.createModal.form.city.value = selectedClient.city
        this.createModal.form.city_national.value = selectedClient.city
        this.createModal.form.company_name.value = selectedClient.company_name
        this.createModal.form.country.value = this.getCountries.find(item => item.id === selectedClient.country_id)
        this.createModal.form.email.value = selectedClient.email
        this.createModal.form.first_name.value = selectedClient.first_name
        this.createModal.form.first_name_national.value = selectedClient.first_name
        this.createModal.form.last_name.value = selectedClient.last_name
        this.createModal.form.last_name_national.value = selectedClient.last_name
        this.createModal.form.phone.value = selectedClient.phone
        this.createModal.form.zip_code.value = selectedClient.zip_code
      }
      return true
    },
    fetchAllData () {
      this.fetchBankDetails()
      Promise.all([
        this.fetchAllClients(),
        this.fetchBusinessEntityTypes(),
        this.fetchCountries(),
        this.fetchCurrencies()
      ])
        .then(values => {
          this.setAllOptionsFilter()
        })
    },
    updateWithUpworkData () {
      this.createModal.form.currency.value = this.getCurrencies.find(item => item.code === 'USD')
      this.createModal.form.business_entity_type.value = this.getBusinessEntityTypes.find(item => item.type === 'Company')
      this.createModal.form.company_name.value = 'Upwork'
      this.createModal.form.company_name_national.value = 'Upwork'
      this.createModal.form.first_name.value = 'Upwork'
      this.createModal.form.first_name_national.value = 'Upwork'
      this.createModal.form.second_name_national.value = 'Upwork'
      this.createModal.form.last_name.value = 'Upwork'
      this.createModal.form.last_name_national.value = 'Upwork'
      this.createModal.form.email.value = 'upwork@email.com'
      this.createModal.form.country.value = this.getCountries.find(item => item.code === 'US')
      this.createModal.form.city.value = 'New York'
      this.createModal.form.city_national.value = 'New York'
      this.createModal.form.address.value = 'New York'
      this.createModal.form.address_national.value = 'New York'
      this.createModal.form.bank_name.value = 'New York Bank'
    },
    setAllOptionsFilter () {
      this.createModal.form.client.options = this.getAllClients
      this.createModal.form.business_entity_type.options = this.getBusinessEntityTypes
      this.createModal.form.country.options = this.getCountries
      this.createModal.form.currency.options = this.getCurrencies

      this.editModal.form.client.options = this.getAllClients
      this.editModal.form.business_entity_type.options = this.getBusinessEntityTypes
      this.editModal.form.country.options = this.getCountries
      this.editModal.form.currency.options = this.getCurrencies

      this.filters.clientId.options = this.getAllClients
      this.filters.businessEntityTypeId.options = this.getBusinessEntityTypes
      this.filters.currencyId.options = this.getCurrencies
      this.filters.country.options = this.getCountries

      this.isDataPageLoading = false
    }
  }
}
</script>
